export default "__VITE_ASSET__DPh5BdfL__"